import { type IUrlParamsService, type UrlParamsName } from './url-params.types';

export class UrlParamsService implements IUrlParamsService {
  readonly #source: URLSearchParams;

  constructor() {
    this.#source = new URLSearchParams(window.location.search);
  }

  getParamByName(paramName: UrlParamsName) {
    return this.#source.get(paramName);
  }

  hasParamByName(paramName: UrlParamsName) {
    return this.#source.has(paramName);
  }

  setParamByName<T extends string>(paramName: UrlParamsName, newParamValue?: T) {
    if (this.#source.get(paramName) === newParamValue) return;

    this.#source.set(paramName, newParamValue || '');

    history.replaceState(null, '', `?${this.#source.toString()}`);
  }

  removeParamByName(paramName: UrlParamsName) {
    if (!this.#source.has(paramName)) return;

    this.#source.delete(paramName);

    history.replaceState(null, '', `?${this.#source.toString()}`);
  }
}
